import React, {useEffect} from 'react';

import {
    MenuItem,
    Stack,
} from '@mui/material';

import {yupResolver} from '@hookform/resolvers/yup';

import {SaveButton} from 'components';
import {useLayoutStore, useSnackbarStore} from 'store';

import {schema, sizes, useApiUpdate} from './useUserApi';

import {Form, FormField, SelectField, useForm} from 'form';

const styles = {
    root: {
        background: theme => theme.palette.grey.darkest,
    },
    fieldContainer: {
        mb: 2
    },
};

const Equipment = ({user, onSave}) => {

    const {update, loading, data, errors} = useApiUpdate(user);

    const setShowLoading = useLayoutStore((state) => state.setShowLoading);
    const showInfo = useSnackbarStore((state) => state.show);

    const rhf = useForm(data, errors, true, {resolver: yupResolver(schema)});

    const doSave = () => {
        rhf.methods.handleSubmit(async formData => {
            try {
                const res = await update(formData);
                showInfo('user.action.save_success');
                if (res !== undefined) {
                    onSave(res);
                }
            } catch (e) {
                showInfo(e.message, {severity: 'warning'});
            }
        })();
    };

    useEffect(() => {
        setShowLoading(loading);
        return () => {
            setShowLoading(false);
        };
    }, [loading, setShowLoading]);

    return (
        <Stack sx={styles.root} direction="column" justifyContent="space-between">
            <Form methods={rhf.methods}>
                <Stack direction="column" justifyContent="flex-end" p={2}>

                    <Stack sx={styles.fieldContainer}>
                        <FormField
                            name="size.shoe"
                            label="user.size.shoe"
                            type="number"
                        />
                    </Stack>

                    <Stack sx={styles.fieldContainer}>
                        <SelectField label="user.size.shirt" name="size.shirt">
                            {sizes.map(sz => <MenuItem key={sz} value={sz}>{sz}</MenuItem>)}
                        </SelectField>
                    </Stack>

                    <Stack sx={styles.fieldContainer}>
                        <SelectField label="user.size.pants" name="size.pants">
                            {sizes.map(sz => <MenuItem key={sz} value={sz}>{sz}</MenuItem>)}
                        </SelectField>
                    </Stack>

                    <Stack sx={styles.fieldContainer}>
                        <SelectField label="user.size.head" name="size.head">
                            {sizes.map(sz => <MenuItem key={sz} value={sz}>{sz}</MenuItem>)}
                        </SelectField>
                    </Stack>

                    <Stack sx={styles.fieldContainer}>
                        <SelectField label="user.size.jacket" name="size.jacket">
                            {sizes.map(sz => <MenuItem key={sz} value={sz}>{sz}</MenuItem>)}
                        </SelectField>
                    </Stack>

                    <SaveButton action={doSave} />

                </Stack>
            </Form>
        </Stack>
    );
};

export default Equipment;